import { Card, Stack, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import Iconify from '../../../../../components/Iconify';

// Compact, solid coloured count card. Kept local instead of changing the pastel StatCard
// in croAssessmentAnalytics, which that page still uses as it is.
export default function ReplacementStatCard({ title, total, icon, color }) {
  return (
    <Card
      sx={{
        p: 1.5,
        height: '100%',
        color: '#fff',
        background: `linear-gradient(135deg, ${color.from} 0%, ${color.to} 100%)`,
        boxShadow: `0 6px 16px ${alpha(color.from, 0.35)}`,
      }}
    >
      <Stack direction="row" alignItems="center" gap={1.5}>
        <Stack
          alignItems="center"
          justifyContent="center"
          sx={{
            width: 40,
            height: 40,
            flexShrink: 0,
            borderRadius: '50%',
            bgcolor: alpha('#fff', 0.22),
          }}
        >
          <Iconify icon={icon} width={22} height={22} />
        </Stack>

        <Stack sx={{ minWidth: 0 }}>
          <Typography variant="h5" sx={{ lineHeight: 1.2, fontWeight: 700 }}>
            {total}
          </Typography>
          <Typography variant="caption" noWrap sx={{ lineHeight: 1.2, fontWeight: 600, opacity: 0.92 }}>
            {title}
          </Typography>
        </Stack>
      </Stack>
    </Card>
  );
}
